/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PageIssueCategoriesQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type PageIssueCategoriesQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly isPrioritized: boolean, readonly lastCheckedAt: CK.Timestamp | null, readonly pageTypeData: { readonly __typename?: 'PageTypeData', readonly issueCategories: ReadonlyArray<{ readonly __typename?: 'PageIssueCategory', readonly configuration: Record<string, any>, readonly context: Record<string, any>, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueCategoryState, readonly issues: ReadonlyArray<{ readonly __typename?: 'PageIssue', readonly configuration: Record<string, any>, readonly context: Record<string, any>, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueState, readonly followupIssues: ReadonlyArray<{ readonly __typename?: 'PageIssue', readonly configuration: Record<string, any>, readonly context: Record<string, any>, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueState, readonly ignoringRuleOnCases: { readonly __typename?: 'PageIssueIgnoringRuleOnCases', readonly id: CK.ID, readonly ignoredCases: ReadonlyArray<any>, readonly isEffective: boolean }, readonly ignoringRuleOnPage: { readonly __typename?: 'PageIssueIgnoringRuleOnPage', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean }, readonly ignoringRuleOnSegments: { readonly __typename?: 'PageIssueIgnoringRuleOnSegments', readonly id: CK.ID, readonly ignoredSegments: ReadonlyArray<string>, readonly isEffective: boolean }, readonly ignoringRuleOnWebsite: { readonly __typename?: 'IssueIgnoringRuleOnWebsite', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean } }>, readonly ignoringRuleOnCases: { readonly __typename?: 'PageIssueIgnoringRuleOnCases', readonly id: CK.ID, readonly ignoredCases: ReadonlyArray<any>, readonly isEffective: boolean }, readonly ignoringRuleOnPage: { readonly __typename?: 'PageIssueIgnoringRuleOnPage', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean }, readonly ignoringRuleOnSegments: { readonly __typename?: 'PageIssueIgnoringRuleOnSegments', readonly id: CK.ID, readonly ignoredSegments: ReadonlyArray<string>, readonly isEffective: boolean }, readonly ignoringRuleOnWebsite: { readonly __typename?: 'IssueIgnoringRuleOnWebsite', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean } }> }> } | null } | null };

export type PageIssueFragmentFragment = { readonly __typename?: 'PageIssue', readonly configuration: Record<string, any>, readonly context: Record<string, any>, readonly isActionable: boolean, readonly isConfigurationModified: boolean, readonly isIgnored: boolean, readonly name: string, readonly pointsGained: number, readonly pointsToGain: number, readonly state: GraphQL.IssueState, readonly ignoringRuleOnCases: { readonly __typename?: 'PageIssueIgnoringRuleOnCases', readonly id: CK.ID, readonly ignoredCases: ReadonlyArray<any>, readonly isEffective: boolean }, readonly ignoringRuleOnPage: { readonly __typename?: 'PageIssueIgnoringRuleOnPage', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean }, readonly ignoringRuleOnSegments: { readonly __typename?: 'PageIssueIgnoringRuleOnSegments', readonly id: CK.ID, readonly ignoredSegments: ReadonlyArray<string>, readonly isEffective: boolean }, readonly ignoringRuleOnWebsite: { readonly __typename?: 'IssueIgnoringRuleOnWebsite', readonly id: CK.ID, readonly isActive: boolean, readonly isEffective: boolean } };

export const PageIssueFragmentFragmentDoc = gql`
    fragment PageIssueFragment on PageIssue {
  configuration
  context
  ignoringRuleOnCases {
    id
    ignoredCases
    isEffective
  }
  ignoringRuleOnPage {
    id
    isActive
    isEffective
  }
  ignoringRuleOnSegments {
    id
    ignoredSegments
    isEffective
  }
  ignoringRuleOnWebsite {
    id
    isActive
    isEffective
  }
  isActionable
  isConfigurationModified
  isIgnored
  name
  pointsGained
  pointsToGain
  state
}
    `;
export const PageIssueCategoriesDocument = gql`
    query PageIssueCategories($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    isPrioritized
    lastCheckedAt
    pageTypeData {
      issueCategories {
        configuration
        context
        isActionable
        isConfigurationModified
        isIgnored
        issues {
          ...PageIssueFragment
          followupIssues {
            ...PageIssueFragment
          }
        }
        name
        pointsGained
        pointsToGain
        state
      }
    }
  }
}
    ${PageIssueFragmentFragmentDoc}`;

/**
 * __usePageIssueCategoriesQuery__
 *
 * To run a query within a React component, call `usePageIssueCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageIssueCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageIssueCategoriesQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function usePageIssueCategoriesQuery(baseOptions: Apollo.QueryHookOptions<PageIssueCategoriesQuery, PageIssueCategoriesQueryVariables> & ({ variables: PageIssueCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageIssueCategoriesQuery, PageIssueCategoriesQueryVariables>(PageIssueCategoriesDocument, options);
      }
export function usePageIssueCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageIssueCategoriesQuery, PageIssueCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageIssueCategoriesQuery, PageIssueCategoriesQueryVariables>(PageIssueCategoriesDocument, options);
        }
export function usePageIssueCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageIssueCategoriesQuery, PageIssueCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageIssueCategoriesQuery, PageIssueCategoriesQueryVariables>(PageIssueCategoriesDocument, options);
        }
export type PageIssueCategoriesQueryHookResult = ReturnType<typeof usePageIssueCategoriesQuery>;
export type PageIssueCategoriesLazyQueryHookResult = ReturnType<typeof usePageIssueCategoriesLazyQuery>;
export type PageIssueCategoriesSuspenseQueryHookResult = ReturnType<typeof usePageIssueCategoriesSuspenseQuery>;
export type PageIssueCategoriesQueryResult = Apollo.QueryResult<PageIssueCategoriesQuery, PageIssueCategoriesQueryVariables>;